import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-prices/rent-objects/${formData.rentObjectId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-prices/rent-objects/${formData.id}`);
  },
  async update(formData) {
    return axios.put(`/rent-object-prices/${formData.id}`, formData);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-prices/${id}`);
  },
};
